
export const SALE_TYPE = {
  "NONE": "0",
  "NORMAL": "1",
  "AUCTION": "2"
}